import { inject, Injectable } from '@angular/core';

import { RegistrationFacade } from '@app/features/registration/services/registration.facade';

import { AppBootstrapService } from './app-bootstrap.service';
import { AppCityService } from './app-city.service';
import { AppProvinceService } from './app-province.service';

@Injectable({
  providedIn: 'root',
})
export class SessionCleanupService {
  private readonly bootstrap = inject(AppBootstrapService);
  private readonly province = inject(AppProvinceService);
  private readonly city = inject(AppCityService);
  private readonly registration = inject(RegistrationFacade);

  clearCachedUserData(): void {
    this.bootstrap.clear();
    this.province.clear();
    this.city.clear();
    this.registration.clear();
  }
}
